import nunjucks from 'nunjucks'
import queryString from 'query-string'
import type { ObjectLike } from '@skedulo/horizon-types'
import { IApiPage } from '../../core/api'
import {
  buildPlatformUrl,
  getAppPreferences,
  getOrgPreferences,
  hasDevFlag,
  hasFeature,
  hasPermission,
  hasPermissions,
  hasRole,
  hasRoles,
} from '../../core/globals'
import { toDate, dateFilter, enumLabel, numberFilter } from '../utils'
import type { TemplateContext } from '../types'

export interface NunjucksSessionData {
  userId?: string
  tenantId?: string
  isSalesforce?: boolean
  isSkedulo?: boolean
  isServiceNow?: boolean
}

export const createNunjucksEnvironment = (
  loader: nunjucks.ILoaderAsync,
  session?: NunjucksSessionData,
  user?: ObjectLike,
  page?: IApiPage,
): nunjucks.Environment => {
  const nunjucksEnvironment = new nunjucks.Environment(loader, {
    trimBlocks: true,
  })

  const queryParams = queryString.parse(window.location.search)

  nunjucksEnvironment
    .addGlobal('_', {
      host: {
        hasFeature,
        hasDevFlag,
        hasPermission,
        hasPermissions,
        hasRole,
        hasRoles,
        buildPlatformUrl,
        getOrgPreferences,
        getAppPreferences,
      },
      queryParams,
      session,
      evaluateTemplate: (template: string, context: ObjectLike) =>
        nunjucksEnvironment.renderString(template, context),
    })
    /** @deprecated Use `$User` instead */
    .addGlobal('$CurrentUser', user)
    .addGlobal('$User', user)
    .addGlobal('$Page', page)
    .addGlobal('toDate', toDate)
    .addFilter('date', dateFilter)
    .addFilter('number', numberFilter)
    .addFilter('enumLabel', enumLabel)

  return nunjucksEnvironment
}

export const renderTemplate = async (
  nunjucksEnvironment: nunjucks.Environment | null,
  templateName?: string,
  templateUid?: string,
  context?: TemplateContext,
) => {
  if (!nunjucksEnvironment || !templateName) return null

  return new Promise<{
    result: string
    templateName?: string
    context?: TemplateContext
  }>((resolve, reject) => {
    nunjucksEnvironment.render(templateName, context ?? {}, (error, result) => {
      if (error) {
        reject(error)
      } else {
        resolve({
          result: result ?? '',
          templateName,
          context: {
            ...context,
            templateUid,
          },
        })
      }
    })
  })
}
